import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as Styled from './GoBackButton.styled';

// Extend Window interface for unsaved changes detection
declare global {
  interface Window {
    hasUnsavedChanges?: boolean;
    showUnsavedChangesModal?: () => Promise<boolean>;
  }
}

interface GoBackButtonProps {
  to: string;
  text: string;
  checkUnsavedChanges?: boolean;
}

const GoBackButton: React.FC<GoBackButtonProps> = ({
  to,
  text,
  checkUnsavedChanges = false
}) => {
  const navigate = useNavigate();

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();

    if (
      checkUnsavedChanges &&
      window.hasUnsavedChanges &&
      window.showUnsavedChangesModal
    ) {
      const shouldContinue = await window.showUnsavedChangesModal();
      if (shouldContinue) {
        navigate(to);
      }
    } else {
      navigate(to);
    }
  };

  if (checkUnsavedChanges) {
    return (
      <Styled.StyledGoBackButton type='primary' onClick={handleClick}>
        {text}
      </Styled.StyledGoBackButton>
    );
  }

  return (
    <Styled.StyledLink to={to}>
      <Styled.StyledGoBackButton type='primary'>
        {text}
      </Styled.StyledGoBackButton>
    </Styled.StyledLink>
  );
};

export default GoBackButton;
